"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDocumentAdd = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M21.65 31.92h25.16a1.28 1.28 0 0 0 0-2.56H21.65a1.28 1.28 0 0 0 0 2.56zM21.65 23.22H42.4a1.28 1.28 0 1 0 0-2.56H21.65a1.28 1.28 0 0 0 0 2.56z"
  }), _react["default"].createElement("path", {
    d: "M54.56 38.37V12.14a3 3 0 0 0-3-3h-34.1a3 3 0 0 0-3 3V60.4a3 3 0 0 0 3 3h17.66a16.37 16.37 0 1 0 19.44-25zm-37.1 22.45a.43.43 0 0 1-.46-.42V12.14a.43.43 0 0 1 .43-.43h34.14a.43.43 0 0 1 .42.43v25.38a16.16 16.16 0 0 0-10.28.8H21.65a1.28 1.28 0 0 0 0 2.56h15.91A16.45 16.45 0 0 0 33 47.13H21.65a1.28 1.28 0 0 0 0 2.56h10.5a16.11 16.11 0 0 0 1.35 11.13zm30.62 6a13.38 13.38 0 1 1 13.39-13.41 13.4 13.4 0 0 1-13.38 13.38z"
  }), _react["default"].createElement("path", {
    d: "M55.43 51.91h-5.84v-5.84a1.5 1.5 0 0 0-3 0v5.84h-5.84a1.5 1.5 0 0 0 0 3h5.84v5.84a1.5 1.5 0 0 0 3 0v-5.84h5.84a1.5 1.5 0 0 0 0-3z"
  })),
  height: undefined,
  width: undefined
});
IconDocumentAdd.displayName = 'IconDocumentAdd';
var _default = IconDocumentAdd;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/document-add.js
// module id = 562
// module chunks = 0